import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Animacao } from '../../core/tools/animacao';
import {
  AjustarPontuacaoItem,
  AjustarPontuacaoService
} from '../../core/services/pontuacao/ajustar-pontuacao.service';

@Component({
  selector: 'app-ajustar-pontuacao',
  templateUrl: './ajustar-pontuacao.component.html',
  styleUrls: ['./ajustar-pontuacao.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class AjustarPontuacaoComponent implements OnInit {
  carregando = false;
  ajustando = false;
  dataDoFiltro: string;
  itens: AjustarPontuacaoItem[] = [];

  constructor(
    private ajustarPontuacaoService: AjustarPontuacaoService,
    private toastr: ToastrService
  ) {
    const hoje = new Date();
    this.dataDoFiltro = this.formatarDataApi(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 2));
  }

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.carregando = true;
    this.ajustarPontuacaoService.getItens(this.dataDoFiltro).subscribe(itens => {
      this.itens = itens || [];
      this.carregando = false;
    }, () => {
      this.carregando = false;
    });
  }

  ajustarNota(item: AjustarPontuacaoItem): void {
    if (item == null || !item.orderIdApp || this.ajustando) {
      return;
    }

    this.ajustando = true;
    this.ajustarPontuacaoService.ajustarNota(item.orderIdApp).subscribe(resultado => {
      this.toastr.success(`${resultado.itensAtualizados || 0} item(ns) atualizado(s).`, 'Pontuação ajustada');
      this.ajustando = false;
      this.carregar();
    }, () => {
      this.ajustando = false;
    });
  }

  ajustarTodas(): void {
    if (this.ajustando || this.itens.length === 0) {
      return;
    }

    if (!confirm('Ajustar a pontuação de todos os itens listados a partir da data informada?')) {
      return;
    }

    this.ajustando = true;
    this.ajustarPontuacaoService.ajustarTodas(this.dataDoFiltro).subscribe(resultado => {
      this.toastr.success(`${resultado.itensAtualizados || 0} item(ns) atualizado(s).`, 'Pontuação ajustada');
      this.ajustando = false;
      this.carregar();
    }, () => {
      this.ajustando = false;
    });
  }

  get totalPontuacao(): number {
    return this.itens.reduce((total, item) => total + (Number(item.pontuacaoAGerar) || 0), 0);
  }

  trackByItem(index: number, item: AjustarPontuacaoItem): number {
    return item.idItem || index;
  }

  formatarNumero(valor: number): string {
    return (Number(valor) || 0).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  private formatarDataApi(data: Date): string {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }
}
